import { useState } from "react";
import { Sparkles, X } from "lucide-react";
import ComingSoonModal from "./ComingSoonModal";

export default function EarlyAccessBanner() {
  const [isVisible, setIsVisible] = useState(true);
  const [showModal, setShowModal] = useState(false);

  if (!isVisible) return null;

  return (
    <>
      <div 
        className="bg-gradient-to-r from-[#4FB3A5]/10 to-[#7BC4A4]/10 border border-[#4FB3A5]/20 rounded-xl p-3 mb-4 relative"
        data-testid="early-access-banner"
      >
        <button
          onClick={() => setIsVisible(false)}
          className="absolute top-2 right-2 p-1 rounded-full hover:bg-white/50 text-[#6B7280] transition-colors"
          aria-label="Dismiss"
        >
          <X size={14} />
        </button>
        
        <div className="flex items-center gap-3 pr-6">
          <div className="w-8 h-8 rounded-lg bg-[#4FB3A5] flex items-center justify-center flex-shrink-0">
            <Sparkles className="text-white" size={16} />
          </div>
          <div className="flex-1">
            <p className="text-xs text-[#1F3A5F] leading-relaxed">
              Early access users get Pro for <span className="font-semibold">$5.99</span> for the entire first year when we launch.
              <button 
                onClick={() => setShowModal(true)}
                className="ml-1 text-[#4FB3A5] hover:underline font-medium"
              >
                Join now →
              </button>
            </p>
          </div>
        </div>
      </div>

      <ComingSoonModal 
        isOpen={showModal} 
        onClose={() => setShowModal(false)} 
      />
    </>
  );
}
